import { Toast } from 'vant';
import NativeShare from 'nativeshare';
export default {
  data() {
    return {
      isWeixin: false,
      isQQ: false,
      share: null,
      shareInfo: {
        title: '手游账号免费估价 . 淘手游',
        desc: '闲来无事估了一下，没想到居然值这么多...',
        link: 'https://static.taoshouyou.com/topic/tsy_gj',
        icon: 'https://static.taoshouyou.com/topic/tsy_gj/img/logo.jpg'
      }
    };
  },

  computed: {
    shareCommand() {
      return this.$store.state.shareCommand;
    }

  },
  // watch: {
  //   shareCommand (val) {
  //     this.callShare(val)
  //   }
  // },
  methods: {
    loadShare() {
      var ua = window.navigator.userAgent.toLowerCase();

      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.isWeixin = true;
      }

      if (ua.match(/QQ/i) == 'qq') {
        this.isQQ = true;
      }

      this.$store.commit('isWeixin', this.isWeixin);
      this.share = new NativeShare({
        syncDescToTag: true,
        syncIconToTag: true,
        syncTitleToTag: true
      }); //分享信息，从游戏中心获取

      this.$http.get('/api/account-price/share', {
        baseURL: this.$store.state.gameBaseUrl
      }).then(res => {
        return res.data;
      }).then(res => {
        if (res.errcode == 0) {
          this.shareInfo = res.data.shareInfo; // document.title = shareInfo.title

          document.querySelectorAll('meta[name="description"]')[1].setAttribute('content', this.shareInfo.desc);
          this.share.setShareData(this.shareInfo); //微信分享

          if (res.data.packageInfo) {
            this.share.setConfig({
              wechatConfig: res.data.packageInfo
            });
          }
        }
      });
      this.$event.on('shareCommand', ({
        command,
        shareInfo
      }) => {
        // this.share.setShareData(shareInfo)
        // document.title = shareInfo.title
        document.querySelectorAll('meta[name="description"]')[1].setAttribute('content', shareInfo.desc);

        if (command) {
          this.callShare(command, shareInfo);
        }
      });
    },

    callShare(command, shareInfo) {
      //百度统计
      window._hmt && window._hmt.push(['_trackEvent', '点击_分享功能', command]); //分享方法

      let data = this.share.getShareData();

      switch (command) {
        case 'wechat':
          try {
            this.share.call('wechatTimeline', shareInfo);
            Toast('点击右上角分享到朋友圈');
          } catch (err) {// Toast('点击右上角分享到朋友圈')
          }

          break;

        case 'qq':
          try {
            this.share.call('qqFriend', shareInfo);
          } catch (err) {
            if (this.isQQ == true) {
              Toast('点击右上角分享给好友');
            } else {
              Toast('当前浏览器暂不支持');
            }
          }

          break;

        case 'weibo':
          try {
            if (this.isWeixin) {
              throw new Error('weixin brower');
            }

            this.share.call('weibo', shareInfo);
          } catch (err) {
            window.location.href = 'http://service.weibo.com/share/share.php?url=' + encodeURIComponent(data.link) + '&title=' + encodeURIComponent(data.title) + '&pic=' + encodeURIComponent(data.icon);
          }

          break;

        case 'link':
          this.$copyText(data.link, undefined, error => {
            if (error) {
              Toast('操作失败');
            } else {
              Toast('复制成功，请粘贴到微信、QQ中分享');
            }
          });
          break;

        default:
      }
    }

  },

  created() {
    this.loadShare();
  }

};